import { useLazyQuery, useQuery } from "@apollo/client";
import { THEMES } from "../theme.queries";
import { ThemesQuery } from "../../../__generated__/ThemesQuery";

export const useThemes = () => {
  return useQuery<ThemesQuery>(THEMES);
};

export const useLazyThemes = () => {
  return useLazyQuery<ThemesQuery>(THEMES);
};
